import {
  api,
  type ApprovalResultResponseDto,
  type BrandRecruiterRequestAddressDto,
  type BrandRecruiterRequestDetailDto,
  type BrandRecruiterRequestItemDto,
  type BrandRecruiterRequestsPaginatedDto,
  type GetBrandRecruiterRequestsPaginatedParams,
  type GetBrandRecruiterRequestsStatus,
  type RejectReasonDto,
} from "@scoutus/sports-metrics";
import { clearDedupeCache, clearDedupeCacheByPrefix, dedupeAsync } from "../utils/dedupeAsync";

export type BrandRecruiterRequestStatus = GetBrandRecruiterRequestsStatus;
export type BrandRecruiterRequestItem = BrandRecruiterRequestItemDto;
export type BrandRecruiterRequestAddress = BrandRecruiterRequestAddressDto;
export type BrandRecruiterRequestDetail = BrandRecruiterRequestDetailDto;

function invalidateBrandRecruiterCaches(): void {
  clearDedupeCacheByPrefix('brand-requests:');
  clearDedupeCache('brand:pending-count');
}

class BrandRecruiterRequestsService {
  async getBrandRecruiterRequests(
    params?: GetBrandRecruiterRequestsPaginatedParams & { search?: string },
  ): Promise<BrandRecruiterRequestsPaginatedDto> {
    const key = `brand-requests:${params?.status ?? 'all'}:${params?.search ?? ''}:${params?.page ?? 1}:${params?.limit ?? 25}`;
    return dedupeAsync(
      key,
      () => api.admin.getBrandRecruiterRequestsPaginated(params ?? undefined),
      { ttlMs: 45_000 },
    );
  }

  async getBrandRecruiterByUserId(
    userId: number | string,
  ): Promise<BrandRecruiterRequestDetail | null> {
    const data = await api.admin.getBrandRecruiterByUserId(Number(userId));
    return data ?? null;
  }

  async approveBrandRecruiter(
    userId: number | string,
  ): Promise<ApprovalResultResponseDto> {
    const result = await api.admin.approveBrandRecruiter(Number(userId));
    invalidateBrandRecruiterCaches();
    return result;
  }

  async rejectBrandRecruiter(
    userId: number | string,
    payload: RejectReasonDto = {},
  ): Promise<ApprovalResultResponseDto> {
    const result = await api.admin.rejectBrandRecruiter(Number(userId), payload);
    invalidateBrandRecruiterCaches();
    return result;
  }
}

export default new BrandRecruiterRequestsService();
